module.exports = __webpack_public_path__ + "static/media/pz.c2278a4b.hdr";